var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}.cls-2{fill:#ffffff;}.cls-3{fill:#ffffff;}.cls-4{fill:#ffffff;}.cls-5{fill:#babbbf;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.641,21.1l2.494-2.494a.5.5,0,0,0,.146-.353.5.5,0,0,0-.146-.354l-2.977-2.977a.5.5,0,0,0-.707,0l-2.494,2.494a15.382,15.382,0,0,0-4.652-2.244.489.489,0,0,0,.023-.115V9.71h1.523a.5.5,0,0,0,.5-.5V5a.5.5,0,0,0-.5-.5H24.207a.5.5,0,0,0-.5.5V9.21a.5.5,0,0,0,.5.5h1.522v5.347a.444.444,0,0,0,.024.115,15.346,15.346,0,0,0-2.583,1.009.493.493,0,0,0,.113-.312V11.915a.5.5,0,0,0-.43-.495l-2.234-.315,1.358-1.8a.5.5,0,0,0-.046-.654l-2.8-2.8a.5.5,0,0,0-.655-.046l-1.8,1.358L16.363,4.93a.5.5,0,0,0-.495-.43H11.915a.5.5,0,0,0-.495.43l-.315,2.235L9.3,5.807a.5.5,0,0,0-.655.046l-2.795,2.8a.5.5,0,0,0-.046.654l1.357,1.8-2.233.315a.5.5,0,0,0-.431.495v3.954a.5.5,0,0,0,.431.5l2.233.314-1.357,1.8a.5.5,0,0,0,.046.655l2.8,2.8a.5.5,0,0,0,.655.046l1.8-1.358.315,2.235a.5.5,0,0,0,.495.43h3.953a.5.5,0,0,0,.314-.114,15.345,15.345,0,0,0-1.624,6.858,15.615,15.615,0,0,0,.158,2.167l-.475.357-.22-1.571a.5.5,0,0,0-.5-.43h-3.1a.5.5,0,0,0-.495.43l-.222,1.571L8.44,31.6a.5.5,0,0,0-.654.046L5.593,33.837a.5.5,0,0,0-.046.654L6.5,35.759l-1.57.22a.5.5,0,0,0-.431.5v3.1a.5.5,0,0,0,.431.495l1.57.222L5.547,41.56a.5.5,0,0,0,.046.654l2.193,2.193a.5.5,0,0,0,.654.046L9.707,43.5l.222,1.57a.5.5,0,0,0,.495.431h3.1a.5.5,0,0,0,.5-.431l.22-1.57,1.268.954a.5.5,0,0,0,.654-.046l2.193-2.193a.5.5,0,0,0,.046-.654l-.954-1.267.905-.128A15.456,15.456,0,0,0,42.641,21.1ZM11.975,40.926a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,11.975,40.926Zm4.4-18.158.3-2.149.7.529A15.63,15.63,0,0,0,16.375,22.768Zm-2.483-5.041a3.835,3.835,0,1,1,3.835-3.835A3.84,3.84,0,0,1,13.892,17.727Zm7.256-.347-.529-.7,2.148-.3A15.336,15.336,0,0,0,21.148,17.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.028,44.5a14.433,14.433,0,0,1-10.642-4.7.481.481,0,0,0,.063-.228v-3.1a.5.5,0,0,0-.43-.5l-1.571-.22.954-1.268a.5.5,0,0,0-.046-.654l-2.193-2.193a.5.5,0,0,0-.519-.114,14.712,14.712,0,0,1-.086-1.5A14.471,14.471,0,1,1,30.028,44.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.005,18.226a11.8,11.8,0,1,0,11.8,11.8A11.816,11.816,0,0,0,30.005,18.226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.005,40.831a10.8,10.8,0,1,1,10.8-10.8A10.815,10.815,0,0,1,30.005,40.831Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.64,15.806l2.643-.372V12.35l-2.643-.373a.5.5,0,0,1-.33-.8l1.606-2.132L18.735,6.867,16.6,8.474a.5.5,0,0,1-.8-.33L15.434,5.5H12.35l-.372,2.644a.5.5,0,0,1-.8.33L9.048,6.867,6.867,9.049l1.607,2.132a.5.5,0,0,1-.33.8L5.5,12.35v3.084l2.644.372a.5.5,0,0,1,.33.8L6.867,18.735l2.181,2.182,2.134-1.607a.5.5,0,0,1,.8.33l.372,2.644h3.084l.373-2.644a.5.5,0,0,1,.8-.33l1.376,1.037a15.64,15.64,0,0,1,2.368-2.368L19.31,16.6a.5.5,0,0,1,.33-.8Zm-5.748,1.921a3.835,3.835,0,1,1,3.835-3.835A3.84,3.84,0,0,1,13.892,17.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.892,9.057a4.835,4.835,0,1,0,4.835,4.835A4.841,4.841,0,0,0,13.892,9.057Zm0,8.67a3.835,3.835,0,1,1,3.835-3.835A3.84,3.84,0,0,1,13.892,17.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.469,39.421l1.98-.279V36.909l-1.98-.278a.5.5,0,0,1-.33-.8l1.2-1.6-1.578-1.578-1.6,1.2a.5.5,0,0,1-.8-.33l-.278-1.98H10.858l-.279,1.98a.5.5,0,0,1-.8.33l-1.6-1.2L6.607,34.236l1.2,1.6a.5.5,0,0,1-.331.8l-1.98.278v2.233l1.98.279a.5.5,0,0,1,.331.8l-1.2,1.6,1.579,1.579,1.6-1.2a.5.5,0,0,1,.8.331l.279,1.98h2.233l.278-1.98a.5.5,0,0,1,.8-.331l1.6,1.2,1.578-1.579-1.2-1.6a.5.5,0,0,1,.33-.8Zm-4.494,1.505a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,11.975,40.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.975,34.125a3.9,3.9,0,1,0,3.9,3.9A3.905,3.905,0,0,0,11.975,34.125Zm0,6.8a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,11.975,40.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.313,29.528h-6.1a2.255,2.255,0,0,0-1.712-1.7V21.439a.5.5,0,0,0-1,0v6.409a2.245,2.245,0,1,0,2.712,2.68h6.1a.5.5,0,0,0,0-1Zm-8.285,1.749a1.249,1.249,0,1,1,1.249-1.249A1.25,1.25,0,0,1,30.028,31.277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.028,36.683a.5.5,0,0,0-.5.5v1.626a.5.5,0,0,0,1,0V37.183A.5.5,0,0,0,30.028,36.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.446,30.028a.5.5,0,0,0-.5-.5H21.32a.5.5,0,0,0,0,1h1.626A.5.5,0,0,0,23.446,30.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,35.984a.5.5,0,0,0-.865.5l.812,1.409a.5.5,0,0,0,.865-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.107,22.309a.5.5,0,1,0-.865.5l.813,1.408a.5.5,0,0,0,.432.25.5.5,0,0,0,.25-.067.5.5,0,0,0,.183-.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.609,33.146,22.2,33.96a.5.5,0,1,0,.5.865l1.408-.813a.5.5,0,1,0-.5-.866Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.126,27a.494.494,0,0,0,.25-.067l1.409-.813a.5.5,0,1,0-.5-.866l-1.409.813a.5.5,0,0,0,.25.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.815,34l-1.408-.813a.5.5,0,0,0-.5.866l1.408.812a.5.5,0,1,0,.5-.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.141,26.108,22.732,25.3a.5.5,0,0,0-.5.866l1.409.813a.5.5,0,0,0,.5-.866Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.671,35.748a.5.5,0,0,0-.683.183l-.813,1.408a.5.5,0,1,0,.865.5l.814-1.408A.5.5,0,0,0,26.671,35.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.253,24.346a.5.5,0,0,0,.683-.183l.813-1.408a.5.5,0,1,0-.865-.5l-.814,1.408A.5.5,0,0,0,33.253,24.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.805,15.983l2.269,2.27-2.038,2.038a15.613,15.613,0,0,0-2.27-2.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 3.21,
    width: 10.644,
    x: 24.707,
    y: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.729,9.71h6.6v5.21a15.177,15.177,0,0,0-6.6,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObm);
export default __webpack_public_path__ + "static/media/obm.c63ac63587707c6a0765e07e34b0a38a.svg";
export { ForwardRef as ReactComponent };